// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"186":"44885c5b","350":"b57f8181","501":"335616ce","547":"335616ce","605":"335616ce","654":"7e22ef7e","856":"335616ce"}[chunkId] + ".chunk.css";
};